module.exports = __webpack_public_path__ + "static/media/ts6cr93.e67b6abf.png";